var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal-wrapper",on:{"click":function($event){$event.preventDefault();return _vm.back.apply(null, arguments)}}},[_c('div',{class:{'modal-box': true, 'modal-large': _vm.size === 'large'},on:{"click":function($event){$event.stopPropagation();}}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }